"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var point_1 = require("../../models/point");
var direction_1 = require("../../models/direction");
function hexagonAnchors(node) {
    node.anchors.push(new point_1.Point(node.rect.x + node.rect.width / 2, node.rect.y, direction_1.Direction.Up));
    node.anchors.push(new point_1.Point(node.rect.x + node.rect.width, node.rect.y + node.rect.height / 2, direction_1.Direction.Right));
    node.anchors.push(new point_1.Point(node.rect.x + node.rect.width / 2, node.rect.y + node.rect.height, direction_1.Direction.Bottom));
    node.anchors.push(new point_1.Point(node.rect.x, node.rect.y + node.rect.height / 2, direction_1.Direction.Left));
    var ptLT = new point_1.Point(node.rect.x + node.rect.width / 10, node.rect.y + node.rect.height / 4, direction_1.Direction.Left);
    ptLT.hidden = true;
    node.anchors.push(ptLT);
    var ptRT = new point_1.Point(node.rect.x + node.rect.width / 10, node.rect.y + (node.rect.height * 3) / 4, direction_1.Direction.Left);
    ptRT.hidden = true;
    node.anchors.push(ptRT);
    var ptLB = new point_1.Point(node.rect.x + (node.rect.width * 9) / 10, node.rect.y + node.rect.height / 4, direction_1.Direction.Right);
    ptLB.hidden = true;
    node.anchors.push(ptLB);
    var ptRB = new point_1.Point(node.rect.x + (node.rect.width * 9) / 10, node.rect.y + (node.rect.height * 3) / 4, direction_1.Direction.Right);
    ptRB.hidden = true;
    node.anchors.push(ptRB);
}
exports.hexagonAnchors = hexagonAnchors;
//# sourceMappingURL=hexagon.anchor.js.map